import { Component, OnInit, Input } from '@angular/core';
import { InstallationService } from '../services/installation.service';
import { StatsService } from '../services/stats.service';
import { DependencesService } from '../services/dependences.service';
import * as Highcharts from 'highcharts';
import { HighchartsService } from '../services/highcharts.service';
import { LogbookService } from '../services/logbook.service';
import * as moment from 'moment';

@Component({
  selector: 'ngx-total-statistics',
  templateUrl: './total-statistics.component.html',
  styleUrls: ['./total-statistics.component.scss'],
})
export class TotalStatisticsComponent implements OnInit {
  @Input() userId: any;
  stations = [];
  dependences = [];
  logbooks = [];
  loading = false;
  range = {
    startDate: moment().startOf('year'),
    endDate: moment().endOf('year'),
  };
  logbooksTypes = [
    'No type logbooks with 0',
    'Mantenimientos',
    'Accidentes e incidentes',
    'Recepción y descarga',
    'Desviaciones en el balance del producto',
    'Revisión de baterías',
    'Apertura de puertas',
    'Residuos peligrosos',
    'Limpieza de sitios contaminados',
    'Extintores',
    'Hermeticidad',
  ];

  constructor(
    private stationsService: InstallationService,
    private statsService: StatsService,
    private dependencesService: DependencesService,
    private highchartsService: HighchartsService,
    private logbookService: LogbookService,
  ) { }

  ngOnInit() {
    this.loading = true;
    Promise.all([this.getStations(), this.getDependendes()]).then(_ => {
      this.getStats();
    });
  }

  async getDependendes() {
    const [error, { data: dependences }] = await this.dependencesService.all();
    if (error) return console.log(error);
    this.dependences = dependences;
  }

  async getStations() {
    const [error, { data }] = await this.stationsService.getStations(true) as any;
    if (error) return console.log(error);
    this.stations = data;
  }

  getStats() {
    Promise.all([this.getDependencesStats(), this.getStationsStats(), this.getLogbooksStats()]).then(_ => {
      this.drawCharts();
      this.loading = false;
    });
  }

  getDependencesStats() {
    const promises = [];
    this.dependences.map(dependence => promises.push(this.statsService.getStationsStats(this.userId, dependence.id, false)));

    return Promise.all(promises).then(data => {
      this.dependences = this.dependences.map((dependence, index) => {
        return {
          ...dependence,
          ...data[index],
        };
      });

      return this.dependences;
    });
  }

  async getStationsStats() {
    const promises = [];
    this.stations.map(station => promises.push(this.statsService.getStats(station.id, false)));

    return Promise.all(promises).then(data => {
      const dataStations = data.map(el => el.data);

      this.stations = this.stations.map((station, index) => {
        return {
          ...station,
          dependencesStats: dataStations[index],
        };
      });

      return this.stations;
    });
  }

  async getLogbooksStats() {
    const promises = [];
    this.stations.map(station => promises.push(this.logbookService.getIndicatorsStation(station.id, this.range,false)));

    return Promise.all(promises).then(data => {
      const dataStations = data.map(el => el.data);
      this.stations = this.stations.map((station, index) => {
        return {
          ...station,
          logbookStats: dataStations[index].map(el => {
            return {
              ...el,
              type_name: this.logbooksTypes[el.type],
            };
          }),
        };
      });

      return this.stations;
    });
  }

  drawCharts() {
    this.drawDependencesChart();
    this.drawStationsChart();
    this.drawLogbooksChart();
  }

  drawDependencesChart() {
    const options = this.highchartsService.drawCompareBars({
      prevData: this.dependences.map(dependence => [dependence.name, dependence.totalRequirements]),
      currentData: this.dependences.map(dependence => [dependence.name, dependence.totalDelivered]),
      data: this.dependences,
      coincidenceToFindLogo: 'name',
    });
    // @ts-ignore
    Highcharts.chart('dependences', options);
  }

  drawStationsChart() {
    const totalDataStations = this.stations.map(station => {
      const sumTotal = station.dependencesStats.reduce((a, b) => a + (b['total_requirements'] || 0), 0);
      return [`${station.business_name} - ${station.acronym}`, sumTotal];
    });

    const totalDeliveredStations = this.stations.map(station => {
      const sumTotal = station.dependencesStats.reduce((a, b) => a + (b['total_delivered'] || 0), 0);
      return [`${station.business_name} - ${station.acronym}`, sumTotal];
    });


    const options = this.highchartsService.drawCompareBars({
      prevData: totalDataStations,
      currentData: totalDeliveredStations,
      data: this.stations,
      coincidenceToFindLogo: 'business_name',
      secondcCoincidenceToFindLogo: 'acronym',
    });
    // @ts-ignore
    Highcharts.chart('stations', options);
  }

  drawLogbooksChart() {
    const series = [];
    this.logbooksTypes.forEach((type, index) => {
      if (index > 0) {
        series.push({
          name: type,
          data: this.stations.map(station => {
            const stat = station.logbookStats.find(el => el.type === index);
            return stat ? stat.total ? stat.total : 0 : 0;
          }),
        });
      }
    });

    const options: any = this.highchartsService.drawLogbooksBars({
      stationNames: this.stations.map(station => station.business_name),
      series,
    });

    Highcharts.chart('logbooks', options);
  }

}
